

import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../public css/Header.css";
import logo from "../assets/Logo.jpeg";

import {
  Menu,
  X,
  Home as HomeIcon,
  Info,
  Phone,
  CreditCard,
  LogIn,
} from "lucide-react";

const Header = () => {
  const [mobileMenu, setMobileMenu] = useState(false);

  const location = useLocation();

  // Close mobile menu when route changes
  useEffect(() => {
    setMobileMenu(false);
  }, [location.pathname]);

  // Prevent background scrolling when sidebar is open
  useEffect(() => {
    if (mobileMenu) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileMenu]);

  const closeMobileMenu = () => {
    setMobileMenu(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenu((prev) => !prev);
  };

  const isActive = (path) => {
    return location.pathname === path ? "active" : "";
  };

  return (
    <>
      {/* =================================================
          HEADER
      ================================================= */}

      <header className="billing-header">

        {/* ================= LOGO ================= */}

        <Link
          to="/"
          className="billing-logo"
          onClick={closeMobileMenu}
        >
          <img
            src={logo}
            alt="Dectwin Billing"
            className="billing-logo-img"
          />

          <div className="logo-text">
            <span>Dectwin</span>
            <small>Billing</small>
          </div>
        </Link>


        {/* ================= DESKTOP NAV ================= */}

        {/* <nav className="desktop-nav">

          <Link
            to="/"
            className={isActive("/")}
          >
            Home
          </Link>

          <Link
            to="/about"
            className={isActive("/about")}
          >
            About
          </Link>

          <Link
            to="/contact"
            className={isActive("/contact")}
          >
            Contact
          </Link>

          <Link
            to="/pricing"
            className={isActive("/pricing")}
          >
            Pricing
          </Link>

        </nav> */}
<nav className="desktop-nav">

  <Link
    to="/"
    className={isActive("/")}
  >
    Home
  </Link>

  <Link
    to="/about"
    className={isActive("/about")}
  >
    About
  </Link>

  <Link
    to="/contact"
    className={isActive("/contact")}
  >
    Contact
  </Link>

  <Link
    to="/pricing"
    className={isActive("/pricing")}
  >
    Pricing
  </Link>

  {/* LOGIN BUTTON */}
  {/* <Link
    to="/login"
    className={`header-login-btn ${
      location.pathname === "/login" ? "login-active" : ""
    }`}
  > */}
<Link
  to="/login?signin=1"
  onClick={(e) => {
    // Agar already Login page par hain,
    // to page reload karke Sign In state reset karo
    if (location.pathname === "/login") {
      e.preventDefault();
      window.location.href = "/login?signin=1";
    }
  }}
  className={`header-login-btn ${
    location.pathname === "/login" ? "login-active" : ""
  }`}
>
  <LogIn size={16} />
  <span>Login</span>
</Link>

</nav>

        {/* ================= MOBILE MENU BUTTON ================= */}

        <button
          type="button"
          className="mobile-menu-btn"
          onClick={toggleMobileMenu}
          aria-label={
            mobileMenu
              ? "Close Menu"
              : "Open Menu"
          }
          aria-expanded={mobileMenu}
        >
          {mobileMenu ? (
            <X size={24} />
          ) : (
            <Menu size={24} />
          )}
        </button>

      </header>


      {/* =================================================
          MOBILE SIDEBAR
      ================================================= */}

      <aside
        className={`mobile-sidebar ${
          mobileMenu ? "show" : ""
        }`}
        aria-hidden={!mobileMenu}
      >

        {/* ================= SIDEBAR HEADER ================= */}

        <div className="mobile-sidebar-header">

          <Link
            to="/"
            className="mobile-logo"
            onClick={closeMobileMenu}
          >
            <img
              src={logo}
              alt="Dectwin Billing"
              className="billing-logo-img"
            />

            <div className="logo-text">
              <span>Dectwin</span>
              <small>Billing</small>
            </div>
          </Link>


          <button
            type="button"
            className="mobile-close-btn"
            onClick={closeMobileMenu}
            aria-label="Close Menu"
          >
            <X size={22} />
          </button>

        </div>


        {/* ================= MOBILE NAV ================= */}
{/* 
        <nav className="mobile-nav">

          <Link
            to="/"
            onClick={closeMobileMenu}
            className={isActive("/")}
          >
            <HomeIcon size={19} />
            <span>Home</span>
          </Link>


          <Link
            to="/about"
            onClick={closeMobileMenu}
            className={isActive("/about")}
          >
            <Info size={19} />
            <span>About</span>
          </Link>


          <Link
            to="/contact"
            onClick={closeMobileMenu}
            className={isActive("/contact")}
          >
            <Phone size={19} />
            <span>Contact</span>
          </Link>


          <Link
            to="/pricing"
            onClick={closeMobileMenu}
            className={isActive("/pricing")}
          >
            <CreditCard size={19} />
            <span>Pricing</span>
          </Link>

        </nav> */}
        <nav className="mobile-nav">

  <Link
    to="/"
    onClick={closeMobileMenu}
    className={isActive("/")}
  >
    <HomeIcon size={19} />
    <span>Home</span>
  </Link>

  <Link
    to="/about"
    onClick={closeMobileMenu}
    className={isActive("/about")}
  >
    <Info size={19} />
    <span>About</span>
  </Link>

  <Link
    to="/contact"
    onClick={closeMobileMenu}
    className={isActive("/contact")}
  >
    <Phone size={19} />
    <span>Contact</span>
  </Link>

  <Link
    to="/pricing"
    onClick={closeMobileMenu}
    className={isActive("/pricing")}
  >
    <CreditCard size={19} />
    <span>Pricing</span>
  </Link>

  {/* MOBILE LOGIN */}
  {/* <Link
    to="/login"
    onClick={closeMobileMenu}
    className={`mobile-login-btn ${
      location.pathname === "/login" ? "login-active" : ""
    }`}
  >
    <LogIn size={19} />
    <span>Login</span>
  </Link> */}
    {/* MOBILE LOGIN */}
<Link
  to="/login?signin=1"
  onClick={(e) => {
    closeMobileMenu();

    if (location.pathname === "/login") {
      e.preventDefault();
      window.location.href = "/login?signin=1";
    }
  }}
  className={`mobile-login-btn ${
    location.pathname === "/login" ? "login-active" : ""
  }`}
>
  <LogIn size={19} />
  <span>Login</span>
</Link>


</nav>

      </aside>


      {/* =================================================
          OVERLAY
      ================================================= */}

      {mobileMenu && (
        <div
          className="mobile-overlay"
          onClick={closeMobileMenu}
          aria-hidden="true"
        />
      )}
    </>
  );
};

export default Header;